export default () => ({
  qty: 1,
  price: null,
  variantID: null,
  variantTitle: null,
  bundleID: null,
  closureID: null,
  closureTitle: "",
  logo: null,
  logoMessage: "",
  design: null,
  designMessage: "",
  card: null,
  cardID: null,
  cardMessage: "",
  cardTitle: "",
  message: "",
  loading: false,
  addressFile: null,
  foil: null,
  startVariant: "",

  options: null,
  variantData: null,
  currentVariantId: null,
  currentVariantAvailable: null,
  currentVariantTitle: null,
  productUrl: null,
  section: null,
  available: true,
  addToCartText: null,
  soldOutText: null,
  sizeOptionText: null,
  productHandle: null,
  productId: null,
  variantInventoryQuantity: null,
  variants: [],

  initVariants(
    variantPrice,
    variantID,
    variantTitle,
    randomNumber,
    productUrl,
    startVariant,
    variantAvailable
  ) {
    this.price = variantPrice;
    this.variantID = variantID;
    this.variantTitle = variantTitle;
    this.randomNumber = randomNumber;
    this.productUrl = productUrl;
    this.startVariant = startVariant;
    this.currentVariantId = variantID;
    this.currentVariantTitle = variantTitle;
    this.currentVariantAvailable = variantAvailable;

    this.options = Array.from(
      this.$refs.variantPicker.querySelectorAll("input:checked"),
      (select) => select.value
    );
  },

  addProduct() {
    let formData = new FormData(this.$refs.product_form);
    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        this.$dispatch("cart-updated");
        this.$dispatch("cart-toggle");
        this.loading = false;
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },
  addExtra() {
    // Extra
    let items = [];

    if (this.cardID) {
      items.push({
        id: this.cardID,
        quantity: this.qty,
        properties: {
          Grupp: this.bundleID,
          Meddelande: this.cardMessage,
        },
      });
    }

    if (this.closureID) {
      items.push({
        id: this.closureID,
        quantity: this.qty,
        properties: {
          Grupp: this.bundleID,
        },
      });
    }

    if (this.design && this.startVariant !== "") {
      items.push({
        id: this.startVariant,
        quantity: 1,
        properties: {
          Grupp: this.bundleID,
        },
      });
    }

    if (items.length > 0) {
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: items }),
      })
        .then((response) => {
          this.addProduct();
        })
        .then((response) => {
          this.$dispatch("cart-updated");
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      this.addProduct();
    }
  },
  addToCart() {
    this.loading = true;
    this.addExtra();
  },
  optionChanged(option) {
    const values = option.data.split(":");
    this.variantID = values[0];
    this.variantTitle = values[1];
    this.price = values[2] && values[2];

    window.history.replaceState({}, "", "?variant=" + this.variantID);
  },
  foilChanged(option) {
    this.foil = option.data;

    if (option) {
      localStorage.setItem("foil", JSON.stringify([option]));
    }
  },
  closureChanged(option) {
    const values = option.data.split(":");
    this.closureID = values[0];
    this.closureTitle = values[1];
  },

  updateOptions() {
    this.options = Array.from(
      this.$refs.variantPicker.querySelectorAll("input:checked"),
      (select) => select.value
    );

    this.updateMasterId();
    this.updateVariantInput();
    this.updateURL();
    // this.renderProductInfo();
    this.setAvailability();
  },

  updateMasterId() {
    let variantObj = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    this.currentVariantId = variantObj.id;
    this.currentVariantAvailable = variantObj.available;
    this.currentVariantTitle = variantObj.title;
    this.price = variantObj.price / 100;
  },

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        this.$refs.variantPicker.querySelector('[type="application/json"]')
          .textContent
      );
    return this.variantData;
  },

  updateURL() {
    if (!this.currentVariantId) return;
    window.history.replaceState(
      {},
      "",
      `${this.productUrl}?variant=${this.currentVariantId}`
    );
  },
  setAvailability() {
    this.variants.forEach(
      function (arrayItem) {
        if (this.currentVariantId == arrayItem.id) {
          if (arrayItem.available) {
            this.currentVariantAvailable = arrayItem.available;
          }

          this.variantInventoryQuantity = arrayItem.quantity;
        }
      }.bind(this)
    );
  },

  setVariants(id, quantity, available) {
    this.variants.push({
      id: id,
      quantity: quantity,
      available: available,
    });
  },
  updateVariantInput() {
    const inputs = document.querySelectorAll('input[name="id"]');
    for (const input of inputs) {
      input.value = this.currentVariantId;
    }
  },

  isVariantAvailable(text) {
    const variantData =
      this.variantData ||
      JSON.parse(
        this.$refs.variantPicker.querySelector('[type="application/json"]')
          .textContent
      );
    const variant = variantData.find((variant) => variant.option2 === text);
    if (variant) {
      if (variant.available) {
        return true;
      }
      return false;
    }
  },
});
